import "slick-carousel";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";

export default class Timeline {
  constructor(element) {
    $(".slider-for").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: ".slider-nav",
      infinite: false,
      initialSlide: 5,
      adaptiveHeight: true,
      prevArrow:
        "<img class='slick-prev' src='../wp-content/themes/era-american/dist/images/svg/icon-timeline-prev.svg'>",
      nextArrow:
        "<img class='slick-next' src='../wp-content/themes/era-american/dist/images/svg/icon-timeline-next.svg'>",
    });

    $(".slider-nav").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      centerPadding: "45%",
      asNavFor: ".slider-for",
      dots: false,
      arrows: false,
      centerMode: true,
      focusOnSelect: true,
      infinite: false,
      initialSlide: 5,
      variableWidth: true,
      variableHeight: true,
    });
  }
}
